// Copyright (c) Microsoft. All rights reserved.

import { ChatArchive } from '../models/ChatArchive';
import { IChatArchiveSession, IChatSession } from '../models/ChatSession';
import { BaseService } from './BaseService';
import { IChatMessage } from '../models/ChatMessage';

export class ChatArchiveService extends BaseService {
    public downloadAsync = async (chatId: string, accessToken: string) => {
        // TODO: [Issue #47] Add type for result. See Bot.cs
        const result = await this.getResponseAsync<object>(
            {
                commandPath: `chats/${chatId}/archive`,
                method: 'GET',
            },
            accessToken,
        );

        return result;
    };

    public uploadAsync = async (chatArchive: ChatArchive, accessToken: string) => {
        const result = await this.getResponseAsync<IChatSession>(
            {
                commandPath: 'chats/archives',
                method: 'POST',
                body: chatArchive,
            },
            accessToken,
        );

        return result;
    };

    public listAsync = async (from: Date, to: Date, accessToken: string) => {
        const result = await this.getResponseAsync<IChatArchiveSession[]>(
            {
                commandPath: 'archive',
                method: 'GET',
                query: new URLSearchParams([
                    ['from', from.toISOString()],
                    ['to', to.toISOString()],
                ]),
            },
            accessToken,
        );

        return result;
    };

    public getMessagesAsync = async (chatId: string, accessToken: string) => {
        const result = await this.getResponseAsync<IChatMessage[]>(
            {
                commandPath: `archive/${chatId}/messages`,
                method: 'GET',
            },
            accessToken,
        );

        // Messages are returned with most recent message at index 0 and oldest message at the last index,
        // so we need to reverse the order for render
        return result.reverse();
    };

    public downloadListExcel = async (from: Date, to: Date, accessToken: string) => {
        const result = await this.getResponseBlobAsync(
            {
                commandPath: 'archive/export',
                method: 'GET',
                query: new URLSearchParams([
                    ['from', from.toISOString()],
                    ['to', to.toISOString()],
                ]),
            },
            accessToken,
        );

        return result;
    };
}
